import { getApi } from "./api_instance";

export const getUsersList = async (
  { currentPage, pagelimit, searchQuery, user_type, status },
  dispatch
) => {
  try {
    let string = "";
    if (searchQuery) {
      string = `&searchQuery=${searchQuery}`;
    }
    if (user_type) {
      string = string + `&user_type=${user_type}`;
    }
    if (status) {
      string = string + `&status=${status}`;
    }
    return await getApi({
      apiUrl: `/api/user/all?page=${currentPage}&limit=${pagelimit}${string}`,
      sendToken: true,
      dispatch,
    });
  } catch (error) {
    throw error;
  }
};
